import LeftSection from './leftSection';
import RightSection from './rightSection';
import { Box } from '@mui/material';

const QA_QUOTES = [
    'Quality is not an act, it is a habit. - Aristotle',
    'Testing leads to failure, and failure leads to understanding. - Burt Rutan',
    'The bitterness of poor quality remains long after the sweetness of low price is forgotten. - Benjamin Franklin',
    'Quality is never an accident; it is always the result of high intention. - John Ruskin',
    'It is not the strongest of the species that survives, but the one most responsive to change. - Charles Darwin',
];

const LoginComponent = () => {
    return (
        <Box
            display='flex'
            height='100vh'
            bgcolor='#0F172A'
            overflow='hidden'
        >
           <LeftSection qaQuotes={QA_QUOTES} />
           <RightSection />
        </Box>
    );
}

export default LoginComponent;
